import assetPositionsFactory from '../positions-global/asset-positions-factory';

export default assetPositionsFactory({
  assetCategory: 'genericAssets',
  positionsTo: 1,
});
